import { z } from 'zod';

export const BatchParametrizationForceRunResponseSchema = z.object({
  outcome: z.enum(['started', 'already_running', 'blocked']),
});

export const BatchParametrizationStopResponseSchema = z.object({
  outcome: z.enum(['stopped', 'idle']),
});

export type BatchParametrizationForceRunResponse = z.infer<
  typeof BatchParametrizationForceRunResponseSchema
>;
export type BatchParametrizationStopResponse = z.infer<
  typeof BatchParametrizationStopResponseSchema
>;
